import { render, staticRenderFns } from "./PitchEmailView.vue?vue&type=template&id=3387bf04"
import script from "./PitchEmailView.vue?vue&type=script&lang=js"
export * from "./PitchEmailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports